<template>
  <label
    class="flex w-fit items-center bg-inherit"
    :class="{
      '!w-full': vertical,
      '!pointer-events-none': $attrs.disabled,
    }"
  >
    <input
      v-model="modelValue"
      type="radio"
      :checked="modelValue === value"
      :name="name ?? ''"
      :value="value"
      class="peer cursor-pointer appearance-none rounded-full border-lightSecondaryColor bg-lightSecondaryColor p-xs shadow-inner shadow-gray-300 checked:border-[4px] checked:bg-primary checked:p-[6px] checked:shadow-none disabled:!cursor-not-allowed disabled:!bg-opacity-60 disabled:!shadow-none dark:border-neutral-900 dark:bg-neutral-900 dark:shadow-black dark:checked:bg-primary"
      :class="{
        'isInTabsComponent:!border-lightPrimaryColor isInTabsComponent:!bg-lightPrimaryColor isInTabsComponent:shadow-none isInTabsComponent:checked:!bg-primary dark:isInTabsComponent:!border-neutral-900 dark:isInTabsComponent:!bg-neutral-900 dark:isInTabsComponent:checked:!bg-primary': true,
      }"
      v-bind="$attrs"
      @input="clearErrors"
    />
    <span
      class="cursor-pointer pl-2 peer-disabled:!cursor-not-allowed peer-disabled:text-lightTertiaryColor peer-disabled:dark:text-darkTertiaryColor"
    >
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script setup lang="ts" generic="T">
import { InputHTMLAttributes, inject } from "vue";

import { RadioGroupName, RadioGroupVertical } from "../components/RadioButtonGroup.vue";
import { useErrors } from "../errors/useErrors";

type Props = {
  value: T;
  name?: string;
  label?: string;
} & /* @vue-ignore */ InputHTMLAttributes;
const props = defineProps<Props>();
const modelValue = defineModel<undefined | T>();

const name = inject(RadioGroupName) ?? props.name;
const vertical = inject(RadioGroupVertical);

const { clearErrors } = useErrors();
</script>
